export default function pricePercent(variant: Record<string, number>) {
  return Math.round(100 - (variant.price / variant.compareAtPrice) * 100)
}
